import { forwardRef } from 'react';

import ArrowSVG from '@/public/images/carousel-button-arrow.svg';

interface ArrowButtonProps {
  ariaLabel?: string;
  className?: string;
  trackingClass?: string;
  onClick?: () => void;
}

// eslint-disable-next-line react/display-name
const ArrowButton = forwardRef<HTMLButtonElement, ArrowButtonProps>(
  ({ ariaLabel, className, trackingClass, onClick }, ref) => (
    <button
      aria-label={ariaLabel}
      ref={ref}
      className={`${className} ${trackingClass}`}
      type="button"
      onClick={onClick}
    >
      <ArrowSVG aria-hidden="true" />
    </button>
  ),
);

export { ArrowButton };
